module.exports = __webpack_public_path__ + "static/media/add_fire_permit.fda5beb6.svg";